import React, { useState } from 'react';
import './new-letter.scss';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Navigation } from 'swiper/modules';

// Import images
import img1 from '../../assets/letters/shetkari_raja.jpg';
import img2 from '../../assets/letters/yapari.jpg';
import img3 from '../../assets/letters/Bandhkam.jpeg';
import img4 from '../../assets/letters/vakil.jpg';
import img5 from '../../assets/letters/doctor.jpg';
import img6 from '../../assets/letters/Niradhar.jpeg';
import img7 from '../../assets/letters/anandi.jpg';
import img8 from '../../assets/letters/drushti_abhiyan.jpg';
import img9 from '../../assets/letters/breast_cancer_awarness.jpg';
import { IoClose } from 'react-icons/io5';

const New_letter = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const letters = [
    { id: 1, image: img1 },
    { id: 2, image: img2 },
    { id: 3, image: img3 },
    { id: 4, image: img4 },
    { id: 5, image: img5 },
    { id: 6, image: img6 },
    { id: 7, image: img7 },
    { id: 8, image: img8 },
    { id: 9, image: img9 },
  ];

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const closePopup = () => {
    setSelectedImage(null);
  };

  return (
    <div className="new-letter-parent parent">
        <h2>Letters</h2>
      <Swiper
        slidesPerView={4}
        spaceBetween={30}
        pagination={{
          clickable: true,
        }}
        navigation
        modules={[Pagination, Navigation]}
        className="mySwiper"
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          480: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        }}
      >
        {letters.map((letter) => (
          <SwiperSlide key={letter.id}>
            <div
              className="box top-sec bg-img-cover"
              onClick={() => handleImageClick(letter.image)}
            >
              <img src={letter.image} alt={`Letter ${letter.id}`} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {selectedImage && (
        <div className="popup" onClick={closePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closePopup}>
               <IoClose />
            </button>
            <img src={selectedImage} alt="Selected Letter" />
          </div>
        </div>
      )}
    </div>
  );
};

export default New_letter;
